// bonus-real-controller
export const getGameBonusEndpoint = 'bonus-ms/ms/bonus/real/getActiveGameBonus';
export const getGameBonusDetailEndpoint = 'bonus-ms/ms/bonus/wallet/games';
export const useCouponEndpoint = 'bonus-ms/ms/bonus/real/useCoupon';
//new bonus controller
export const getBonusListEndpoint = 'bonus-ms/ms/bonus/all/getBonusList';
//Freespin/Fun bonus controller
export const getFunBonusList = 'bonus-ms/ms/bonus/wallet/funBonusList';

export const getBonusWagerDetailEndpoint = 'bonus-ms/ms/bonus/all/getBonusById';

export const getFunBonusDetailApiConfig =
  'bonus-ms/ms/bonus/wallet/funBonusDetail/';

export const getBonusFreebetDetailEndpoint =
  'bonus-ms/ms/bonus/wallet/bonusDetail/';

export const getNewBonusListEndpoint = 'bonus-ms/ms/bonus/wallet/bonusList';

export const getBonusSpendabilityEndpoint =
  'bonus-ms/ms/bonus/getBonusSpendability';
